import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const Baseurl = process.env.REACT_APP_API_URL;

export const post_Restaurant = createAsyncThunk(
  "restaurant/post_Restaurant",
  async (formData, thunkAPI) => {
    try {
      const config = {
        headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/restaurant/new`;
      const resp = await axios.post(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("restaurant Not create");
    }
  }
);
export const get_restarent_data = createAsyncThunk(
  "restaurant/get_restarent_data",
  async (slugurl, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/restaurant/all`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);
export const validateEmail = createAsyncThunk(
  "restaurant/validateEmail",
  async (data, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/restaurant/verify-email/${data}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);
export const validateMobile = createAsyncThunk(
  "restaurant/validateMobile",
  async (data, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/restaurant/verify-mobile/${data}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);
export const validateLicence = createAsyncThunk(
  "restaurant/validateLicence",
  async (data, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/restaurant/verify-fssai-lic-no/${data}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);
export const validateGst = createAsyncThunk(
  "restaurant/validateGst",
  async (data, thunkAPI) => {
    try {
      const url = `${Baseurl}/api/v1/restaurant/verify-gst/${data}`;
      const resp = await axios.get(url);
      return resp.data;
    } catch (error) {
      return error;
    }
  }
);

export const restaurentUpdate = createAsyncThunk(
  "restaurant/restaurentUpdate",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/restaurant/update`;
      const resp = await axios.put(url, formData, config);

      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("restaurant Not create");
    }
  }
);

export const restaurentMenuadd = createAsyncThunk(
  "restaurant/restaurentMenuadd",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/restaurant/menu-add`;
      const resp = await axios.put(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("restaurant Not create");
    }
  }
);
export const restaurentMenuUpdate = createAsyncThunk(
  "restaurant/restaurentMenuUpdate",
  async (formData, thunkAPI) => {
    try {
      const config = {
        Headers: { "Content-Type": "application/json" },
      };
      const url = `${Baseurl}/api/v1/restaurant/menu-update`;
      const resp = await axios.put(url, formData, config);
      return resp.data;
    } catch (error) {
      return thunkAPI.rejectWithValue("restaurant Not create");
    }
  }
);

const initialState = {
  restaurant_all: JSON.parse(localStorage.getItem("restaurant_all"))
    ? JSON.parse(localStorage.getItem("restaurant_all")).sort((a, b) =>
        a.createdAt > b.createdAt ? 1 : -1
      )
    : [],
  restaurant_allLoading: true,
  isrestaurant_allAvailable: localStorage.getItem("restaurant_all")
    ? true
    : false,
  restaurantLogo: "",
  restaurantLogoLoading: true,
};

const RestaurantSlice = createSlice({
  name: "restaurant",
  initialState,
  reducers: {
    updateImages(state, action) {
      state.restaurantLogo = action.payload;
      state.restaurantLogoLoading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(post_Restaurant.pending, (state) => {
        state.restaurant_allLoading = true;
      })
      .addCase(post_Restaurant.fulfilled, (state, action) => {
        state.restaurant_all = [
          ...state.restaurant_all,
          action.payload.restaurant,
        ];
        state.restaurant_all = state.restaurant_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem(
          "restaurant_all",
          JSON.stringify(state.restaurant_all)
        );
        state.restaurant_allLoading = false;
        state.isrestaurant_allAvailable = true;
      })
      .addCase(post_Restaurant.rejected, (state) => {
        state.restaurant_allLoading = true;
      });
    builder
      .addCase(get_restarent_data.pending, (state) => {
        state.restaurant_allLoading = true;
      })
      .addCase(get_restarent_data.fulfilled, (state, action) => {
        state.restaurant_all = action.payload.restaurant;
        state.restaurant_all = state.restaurant_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem(
          "restaurant_all",
          JSON.stringify(state.restaurant_all)
        );
        state.restaurant_allLoading = false;
        state.isrestaurant_allAvailable = true;
      })
      .addCase(get_restarent_data.rejected, (state) => {
        state.restaurant_allLoading = true;
      });
    builder
      .addCase(restaurentUpdate.pending, (state) => {
        state.restaurant_allLoading = true;
      })
      .addCase(restaurentUpdate.fulfilled, (state, action) => {
        state.restaurant_all = state.restaurant_all.filter(
          (data) => data._id !== action.payload.restaurant._id
        );
        state.restaurant_all = [
          ...state.restaurant_all,
          action.payload.restaurant,
        ];
        state.restaurant_all = state.restaurant_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem(
          "restaurant_all",
          JSON.stringify(state.restaurant_all)
        );
        state.restaurant_allLoading = false;
        state.isrestaurant_allAvailable = true;
      })
      .addCase(restaurentUpdate.rejected, (state) => {
        state.restaurant_allLoading = true;
      });

    builder
      .addCase(restaurentMenuadd.pending, (state) => {
        state.restaurant_allLoading = true;
      })
      .addCase(restaurentMenuadd.fulfilled, (state, action) => {
        state.restaurant_all = state.restaurant_all.filter(
          (data) => data._id !== action.payload.restaurant._id
        );
        state.restaurant_all = [
          ...state.restaurant_all,
          action.payload.restaurant,
        ];
        state.restaurant_all = state.restaurant_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem(
          "restaurant_all",
          JSON.stringify(state.restaurant_all)
        );
        state.restaurant_allLoading = false;
        state.isrestaurant_allAvailable = true;
      })
      .addCase(restaurentMenuadd.rejected, (state) => {
        state.restaurant_allLoading = true;
      });
    builder
      .addCase(restaurentMenuUpdate.pending, (state) => {
        state.restaurant_allLoading = true;
      })
      .addCase(restaurentMenuUpdate.fulfilled, (state, action) => {
        state.restaurant_all = state.restaurant_all.filter(
          (data) => data._id !== action.payload.restaurant._id
        );
        state.restaurant_all = [
          ...state.restaurant_all,
          action.payload.restaurant,
        ];
        state.restaurant_all = state.restaurant_all.sort((a, b) =>
          a.createdAt > b.createdAt ? 1 : -1
        );

        localStorage.setItem(
          "restaurant_all",
          JSON.stringify(state.restaurant_all)
        );
        state.restaurant_allLoading = false;
        state.isrestaurant_allAvailable = true;
      })
      .addCase(restaurentMenuUpdate.rejected, (state) => {
        state.restaurant_allLoading = true;
      });
  },
});

export const { updateImages } = RestaurantSlice.actions;
export const authActions = RestaurantSlice.actions;
export default RestaurantSlice.reducer;
